import { ApolloClient, InMemoryCache, createHttpLink } from "@apollo/client";
import {
  Redirect,
  Route,
  BrowserRouter as Router,
  Switch,
} from "react-router-dom";

import { ApolloProvider } from "@apollo/client/react";
import AuthProvider from "./AuthProvider";
import React from "react";
import { env } from "./EnvVariables";
import { getAccount } from "./auth-utils";
import { setContext } from "@apollo/client/link/context";

const Adoptions = React.lazy(() => import("./containers/Adoptions.js"));
const CoverSheet = React.lazy(() => import("./containers/CoverSheet.js"));
const WelcomeAdoptions = React.lazy(() =>
  import("./containers/WelcomeAdoptions.js")
);
const WelcomeCoverSheet = React.lazy(() =>
  import("./containers/WelcomeCoverSheet.js")
);
const WelcomeHome = React.lazy(() => import("./containers/WelcomeHome.js"));
const NotFoundPage = React.lazy(() => import("./containers/404.js"));
const ErrorPage = React.lazy(() => import("./containers/Error.js"));
const Logout = React.lazy(() => import("./containers/Logout.js"));

const httpLink = createHttpLink({
  uri: env.REACT_APP_SPARTAN_BFF_URL,
});

const authLink = setContext((_, { headers }) => {
  // get the authentication token from local storage if it exists
  const apitoken = localStorage.getItem("apitoken");
  // return the headers to the context so httpLink can read them
  return {
    headers: {
      ...headers,
      authorization: apitoken ? `Bearer ${apitoken}` : "",
    },
  };
});

const client = new ApolloClient({
  link: authLink.concat(httpLink),
  cache: new InMemoryCache(),
});

const ProtectedRoute = ({ children, ...rest }) => {
  return (
    <Route
      {...rest}
      render={() => {
        if (!getAccount()) {
          return null;
        } else {
          return children;
        }
      }}
    />
  );
};

function App(props) {
  const acceptedPaths = ["/error", "/404", "/logout"];
  const currentPath = new URL(window.location).pathname;

  const urlParams = new URLSearchParams(window.location.search);

  if (
    !urlParams.has("codUnico") &&
    urlParams.get("codUnico") === null &&
    sessionStorage.getItem("codUnico") === null &&
    !urlParams.has("codunico") &&
    urlParams.get("codunico") === null &&
    !acceptedPaths.includes(currentPath)
  ) {
    window.location.href = "/error";
  }
  if (urlParams.has("codUnico") && urlParams.get("codUnico") !== null) {
    sessionStorage.setItem("codUnico", urlParams.getAll("codUnico"));
  }
  if (urlParams.has("codunico") && urlParams.get("codunico") !== null) {
    sessionStorage.setItem("codUnico", urlParams.getAll("codunico"));
  }

  return (
    <ApolloProvider client={client}>
      <Router>
        <Switch>
          <Route
            exact
            path="/"
            render={() => props.account && <Redirect to="/home" />}
          />
          <Route exact path="/logout">
            <React.Suspense fallback="...">
              <Logout />
            </React.Suspense>
          </Route>
          <Route exact path="/error">
            <React.Suspense fallback="...">
              <ErrorPage />
            </React.Suspense>
          </Route>
          <ProtectedRoute exact path="/home">
            <React.Suspense fallback="...">
              <WelcomeHome />
            </React.Suspense>
          </ProtectedRoute>
          <ProtectedRoute exact path="/welcome-adoptions">
            <React.Suspense fallback="...">
              <WelcomeAdoptions />
            </React.Suspense>
          </ProtectedRoute>
          <ProtectedRoute exact path="/adoptions">
            <React.Suspense fallback="...">
              <Adoptions />
            </React.Suspense>
          </ProtectedRoute>
          <ProtectedRoute exact path="/welcome-coversheets">
            <React.Suspense fallback="...">
              <WelcomeCoverSheet />
            </React.Suspense>
          </ProtectedRoute>
          <ProtectedRoute exact path="/coversheets">
            <React.Suspense fallback="...">
              <CoverSheet />
            </React.Suspense>
          </ProtectedRoute>
          <Route>
            <React.Suspense fallback="...">
              <NotFoundPage />
            </React.Suspense>
          </Route>
        </Switch>
      </Router>
    </ApolloProvider>
  );
}

export default AuthProvider(App);
